import { type Property } from 'csstype';
import { ChromePicker } from 'react-color';
import { MdColorLens } from 'react-icons/md';
import styled, { css } from 'styled-components';

import { BaseLabel } from '@gbs-monorepo-packages/common';
import { colors, radii } from '@gbs-monorepo-packages/styles';

export const ChromePickerContainer = styled.div``;

export const CustomChromePicker = styled(ChromePicker)`
  left: 100%;
  position: absolute;
  top: 50%;
  transform: translateX(10px);
  width: 60% !important;
  z-index: 9999;
`;

export const ColorPickerFieldContainer = styled.div`
  align-items: center;
  display: flex;
  max-width: 100%;
  padding: 0;
`;

interface IColorPreviewProps {
  readonly $color: Property.Color;
}

export const ColorPreview = styled.div<IColorPreviewProps>`
  background-color: ${({ $color }) => $color};
  border-bottom-left-radius: ${radii.px};
  border-top-left-radius: ${radii.px};
  border: 1px solid ${colors.fieldFocus};
  display: block;
  height: 3.25rem;
  margin: 0;
  padding: 0;
  text-align: center;
  width: 3.25rem;
`;

export const Label = styled(BaseLabel)`
  background-color: ${colors.white300};
  color: ${colors.labelText};
  font-size: 0.875rem;
  left: 16px;
  max-width: 90%;
  overflow: hidden;
  padding: 1px 6px;
  position: absolute;
  text-overflow: ellipsis;
  top: 50%;
  transform-origin: 0;
  transform: translateY(-50%);
  transition: transform 0.15s ease-in-out, top 0.15s ease-in-out,
    padding 0.15s ease-in-out;
  user-select: none;
  white-space: nowrap;
`;

interface IFieldsetProps {
  readonly filled: boolean;
  readonly isInvalid?: boolean;
}

export const Fieldset = styled.fieldset<IFieldsetProps>`
  all: unset;
  align-items: center;
  background-color: ${colors.white300};
  border-radius: ${radii.px};
  border: 1px solid ${colors.inputBorderLight};
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  justify-content: space-between;
  position: relative;
  transition: box-shadow 0.2s ease-in-out, border-color 0.2s ease-in-out;

  &:focus-within {
    border: 1px solid ${colors.fieldFocus};

    & ${Label} {
      color: ${colors.fieldFocus};
      top: -2px;
      transform: scale(0.88) translateX(-0.5rem) translateY(-50%);
      white-space: normal;
    }
  }

  ${({ filled = false, isInvalid = false }) =>
    filled &&
    (!isInvalid
      ? css`
          border: 1px solid ${colors.fieldFocus};

          & ${Label} {
            color: ${colors.fieldFocus};
            top: -2px;
            transform: scale(0.88) translateX(-0.5rem) translateY(-50%);
            white-space: normal;
          }
        `
      : css`
          border: 1px solid ${colors.red300};

          & ${Label} {
            color: ${colors.red300};
            top: -2px;
            transform: scale(0.88) translateX(-0.5rem) translateY(-50%);
            white-space: normal;
          }
        `)}
`;

export const ColorPickerIcon = styled(MdColorLens)`
  color: ${colors.button};
  cursor: pointer;
  height: 2rem;
  margin-right: 1rem;
  width: 2rem;
`;

export const ErrorMessageContainer = styled.div`
  color: ${colors.red300};
  font-size: 0.875rem;
  margin: -5px 0px 15px 0px;
`;

export const ErrorMessage = styled.p`
  margin-top: 5px;
`;
